import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog'
import { ProgressSpinner } from 'primereact/progressspinner'
import React from 'react'
export default function ModalVisualisarImpactados({ arrayImpactados = [], isVisible, fecharModalAviso, loadingTable }) {
    const header = <h3 style={{ fontWeight: 'bold', fontSize: '18', color: 'red' }}>Quantidade de Inscrições Impactadas: {arrayImpactados.length}</h3>
    return (

        <>
            <Dialog header="Visualizar Inscrições Impactadas" visible={isVisible} style={{ width: '75vw' }} modal={true} onHide={() => fecharModalAviso(false)}>

                {loadingTable && <ProgressSpinner strokeWidth='3' animationDuration='5' />}

                {!loadingTable && 
                    <DataTable 
                    style={{ marginTop: 'auto' }}
                    header={header} dataKey='Inscricao'
                    value={arrayImpactados}
                    responsive
                    rowHover
                    paginator
                    rows={10}
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} resultados encontrados"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    >
                    <Column filter field="Inscricao" header="Inscrição" />
                    <Column filter field="CPF" header="CPF" />
                    <Column filter field="Nome" header="Nome" />
                    </DataTable>}
            </Dialog>

            <Button label="Show" icon="pi pi-info-circle" onClick={() => fecharModalAviso(false)} />
        </>

    )
}
